var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-auto text-capitalize text-white",attrs:{"loading":_vm.loadingBtn,"depressed":"","color":_vm.$colors[0]},on:{"click":function($event){return _vm.downlmoadFileEndesa(_vm.offreId)}}},[_c('v-icon',[_vm._v("mdi-file-upload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }